import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

// Same sun/moon button as the portal top bar, for the public site and the login page.
export const ThemeToggle = ({ className = "", testId = "theme-toggle-button" }) => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={toggle}
      title={dark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label={dark ? "Switch to light mode" : "Switch to dark mode"}
      className={`size-9 rounded-full flex items-center justify-center hover:bg-muted transition-colors text-muted-foreground hover:text-foreground ${className}`}
    >
      {dark ? <Sun className="size-4" /> : <Moon className="size-4" />}
    </button>
  );
};
